import _classCallCheck from "/home/runner/work/web-gamesite/web-gamesite/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web-gamesite/web-gamesite/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { applyAggregateErrorsToEvent, exceptionFromError } from '@sentry/utils';
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
var LinkedErrors = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
  function LinkedErrors() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, LinkedErrors);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
    this.name = LinkedErrors.id;
  }

  /** @inheritdoc */
  _createClass(LinkedErrors, [{
    key: "setupOnce",
    value: function setupOnce() {
      // noop
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "preprocessEvent",
    value: function preprocessEvent(event, hint, client) {
      var options = client.getOptions();
      applyAggregateErrorsToEvent(exceptionFromError, options.stackParser, options.maxValueLength, this._key, this._limit, event, hint);
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'LinkedErrors';
    }
  }]);
  return LinkedErrors;
}();
LinkedErrors.__initStatic();
export { LinkedErrors };